import(/* webpackMode: "eager" */ "/vercel/path0/Frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/Frontend/node_modules/next/dist/client/link.js");
